import { useContext } from 'react';
import { Skeleton, ThemeIcon, Tooltip } from '@mantine/core';
import moment from 'moment';
import { IconCheck, IconRefreshAlert, IconX } from '@tabler/icons';
import { DocumentItemContext } from '../../../Service/Context/DocumentItemContext';

const DocumentBookkeepingStatusIcon = () => {
  const { loading, syncedAt, isUptodate, toolMissing, syncing } = useContext(DocumentItemContext);

  if (loading || syncing) {
    return <Skeleton circle height={20} width={20} />;
  }

  if (toolMissing) return null;

  if (!syncedAt) {
    return (
      <Tooltip label="Buchhaltung: Nicht übermittelt" position="right-start" transition="slide-right">
        <ThemeIcon radius="xl" size="sm" color="silver">
          <IconX size={14} />
        </ThemeIcon>
      </Tooltip>
    );
  }

  return (
    <Tooltip
      label={
        isUptodate
          ? `Buchhaltung: Rechnung übertragen ${moment(syncedAt).format('DD.MM.YY')}`
          : 'Buchhaltung: Nicht auf dem neuesten Stand'
      }
      position="right-start"
      transition="slide-right"
    >
      <ThemeIcon radius="xl" size="sm" color={isUptodate ? 'green' : 'orange'}>
        {isUptodate ? <IconCheck size={14} /> : <IconRefreshAlert size={14} />}
      </ThemeIcon>
    </Tooltip>
  );
};

export default DocumentBookkeepingStatusIcon;
